(function () {
  'use strict';

  var drawer = document.getElementById('fk-cat-drawer');
  if (!drawer) return;

  var panel = drawer.querySelector('.fkd__panel');
  var firstFocusable = null;
  var lastTrigger = null;
  var touchStartX = 0;
  var touchStartY = 0;

  function getFocusable() {
    return Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('fkd--open');
    });
    document.body.style.overflow = 'hidden';
    var focusable = getFocusable();
    firstFocusable = focusable[0] || null;
    if (firstFocusable) firstFocusable.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('fkd--open');
    document.body.style.overflow = '';
    panel.addEventListener(
      'transitionend',
      function handler() {
        drawer.hidden = true;
        panel.removeEventListener('transitionend', handler);
        if (lastTrigger) lastTrigger.focus();
      }
    );
  }

  // Open triggers
  document.querySelectorAll('[data-fk-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      lastTrigger = e.currentTarget;
      openDrawer();
    });
  });

  // Close triggers (overlay + close button + CTA)
  drawer.querySelectorAll('[data-fk-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || drawer.hidden) return;
    closeDrawer();
  });

  // Focus trap
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || drawer.hidden) return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Swipe left to close
  panel.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  panel.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
    if (dx < -56 && dy < 40) closeDrawer();
  }, { passive: true });
})();
